import { computed, DefineComponent, defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
// import router from "@/router";

import { LayoutPlain, LayoutHeaderFooter, LayoutOuterSidebars, LayoutMobileFooter} from '@busy-human/vue-component-library';
import { toRaw } from "vue";

enum Layouts {
    PLAIN = "LayoutPlain",
    INNER_SIDEBARS = "LayoutInnerSidebars",
    OUTER_SIDEBARS = "LayoutOuterSidebars",
	MOBILE_FOOTER = "LayoutMobileFooter"
}

/** If you want to force the current view into a different layout than specified in the router */
export const OverrideLayout = ref<Layouts|null>(null);

export const DefaultLayout = ref<typeof LayoutPlain>(LayoutHeaderFooter);

const route = computed(() => useRoute());

/** Resolves the layout to apply for this view */
export const AppliedLayout = computed(() => {
	//TODO: Find out how to access Route info from VCL
	const meta = route.value?.meta;

	if(OverrideLayout.value) {
		return OverrideLayout.value;
	}

	switch (meta?.layout as Layouts) {
		case Layouts.PLAIN:
			return toRaw(LayoutPlain);
		case Layouts.INNER_SIDEBARS:
			return toRaw(LayoutHeaderFooter);
		case Layouts.OUTER_SIDEBARS:
			return toRaw(LayoutOuterSidebars);
		case Layouts.MOBILE_FOOTER:
			return toRaw(LayoutMobileFooter);
		default:
			if(meta?.layout) {
				console.warn(`Unsupported layout: ${meta.layout}`);
			}
			return toRaw(DefaultLayout.value);
	}
});